<template>
  <div id="app">
    <router-view />
    <pl-tips
      v-if="showTips"
      :body="tipsInfo.content"
      @close="$store.commit('setTipsState', false)"
    ></pl-tips>
    <transition name="fade-in">
      <div
        class="loading-mask"
        v-show="isLoading"
      >
        <div class="loading">
          <span class="loading-item"></span>
          <span class="loading-item"></span>
          <span class="loading-item"></span>
          <span class="loading-item"></span>
          <span class="loading-item"></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import plTips from "@/components/pl-tips";
export default {
  components: { plTips },
  data() {
    return {
      showUpgradeTips: false,
    };
  },
  computed: {
    ...mapGetters({
      showTips: "getShowTips",
      tipsInfo: "getTipsInfo",
      isLoading: "getIsLoading",
    }),
  },
  created() {
    window.onbeforeunload = () => {
      this.$datain({ ext3: "關閉窗口" });
    };
    if (window.matchMedia) {
      let matchMedia = window.matchMedia("(orientation: portrait)");
      matchMedia.addListener((e) => {
        this.$store.commit("setDeviceDirection", e.matches);
      });
      this.$store.commit("setDeviceDirection", matchMedia.matches);
    }
  },
};
</script>

<style lang="scss">
@import "./scss/platform-fonts.scss";
// @font-face {
//   font-family: "cn-regular";
//   src: url("//mstore.gm99.com/fonts/cn-regular.otf");
// }
.platform-number {
  font-family: "platform-number" !important;
}
// .cn-regular {
//   font-family: "cn-regular" !important;
// }
html {
  height: 100%;
  margin: 0;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
  box-sizing: border-box;
}
#app {
  // font-family: "cn-regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 16px;
}
%icon-arrow {
  width: 9px;
  height: 9px;
  display: inline-block;
  border-right: 1px solid #9c9c9c;
  border-bottom: 1px solid #9c9c9c;
}
.icon-arrow_down {
  @extend %icon-arrow;
  transform-origin: right;
  transform: rotate3d(0, 0, 1, 45deg);
  transform: rotate(45deg) \9;
}
.icon-arrow_right {
  @extend %icon-arrow;
  transform-origin: bottom;
  transform: rotate3d(0, 0, 1, -45deg);
  transform: rotate(-45deg) \9;
}
.icon-edit_del {
  $delColor: #FF515A;
  flex-basis: auto !important;
  display: inline-block;
  position: relative;
  width: 18px;
  height: 18px;
  border: 2px solid $delColor;
  border-radius: 50%;
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 2px;
    margin: auto;
    background-color: $delColor;
    transform: translate(-50%, -50%);
  }
}
.upgrade-mask {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  position: fixed;
  text-align: center;
  background: rgba(0, 0, 0, 0.9);
  .upgrade-tips {
    background: #fff;
    height: 36px;
    line-height: 36px;
  }
  .download-link {
    color: #e97d30;
    text-decoration: none;
  }
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.9);
  .loading {
    top: 50%;
    left: 50%;
    width: 80px;
    height: 40px;
    margin-top: -20px;
    margin-left: -40px;
    position: absolute;
  }
  .loading-item {
    width: 8px;
    height: 100%;
    margin-left: 8px;
    border-radius: 4px;
    display: inline-block;
    background: #f3a069;
    animation: load 1s ease infinite;
  }
  @keyframes load {
    0%,
    100% {
      background: #f3a069;
      transform: scale(1, 1);
    }
    50% {
      background: #f2d1a7;
      transform: scale(1, 1.6);
    }
  }
  .loading-item:nth-of-type(2) {
    animation-delay: 0.2s;
  }
  .loading-item:nth-of-type(3) {
    animation-delay: 0.4s;
  }
  .loading-item:nth-of-type(4) {
    animation-delay: 0.6s;
  }
  .loading-item:nth-of-type(5) {
    animation-delay: 0.8s;
  }
}

.text-right {
  text-align: right;
}

.fade-in-enter-active {
  transition: opacity 0.3s;
}
.fade-in-leave-active {
  transition: opacity 0.3s;
}
.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}
</style>
